import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { ApiShivaService } from '@core/apis/api-shiva.service';
import { IEquipmentConstructors, IEquipmentModel, IListResult } from '@core/interfaces';

@Component({
  selector: 'app-pneylu-add-return-equipment-modal',
  templateUrl: './pneylu-add-return-equipment-modal.component.html',
})
export class PneyluAddReturnEquipmentModalComponent implements OnInit {
  private readonly apiShiva = inject(ApiShivaService);
  private readonly toastr = inject(ToastrService);
  private readonly ngbActiveModal = inject(NgbActiveModal);

  public constructorOptions: string[] = [];
  public modelOptions: string[] = [];
  public serial_number?: string;

  public formGroup: FormGroup<{
    constructor_name: FormControl<string>,
    model_name: FormControl<string>,
    quantity: FormControl<number>,
  }>;

  public ngOnInit(): void {
    this.formGroup = new FormGroup({
      constructor_name: new FormControl<string>(null, Validators.required),
      model_name: new FormControl<string>(null, Validators.required),
      quantity: new FormControl<number>(1, [
        Validators.required,
        Validators.min(1),
        // Must only contain numbers, makes sure that the user doesn't try and enter a decimal number
        Validators.pattern(/^\d+$/),
      ]),
    });

    if (this.serial_number) {
      this.formGroup.get('quantity').disable();
    }

    this._loadConstructorOptions();
    this._loadModelOptions();
  }

  public confirm(): void {
    if (this.formGroup.invalid) {
      return;
    }
    const payload = {
      ...this.formGroup.getRawValue(),
      serial_number: this.serial_number
    };
    this.ngbActiveModal.close(payload);
  }

  public dismiss(): void {
    this.ngbActiveModal.dismiss();
  }

  public filterModels(constructorName: string): void {
    this._loadModelOptions(constructorName);
  }

  public getConstructor(modelName: string): void {
    this.apiShiva.equipment_models.list({ branded_name: modelName })
      .then((response: IListResult<IEquipmentModel>) => {
        const model = response.results[0];
        if (model?.brand?.name) {
          this.formGroup.controls['constructor_name'].setValue(model.brand.name);
        }
      })
      .catch((error: unknown) => {
        console.error(error);
        this.toastr.error(`Erreur lors de la récupération des modèles.`);
      });
  }

  private _loadConstructorOptions(): void {
    this.apiShiva.equipment_constructors.list({})
      .then((response: IListResult<IEquipmentConstructors>) => {
        this.constructorOptions = response.results
          .map((constructor: IEquipmentConstructors) => constructor.name)
          .sort();
      })
      .catch((error: unknown) => {
        console.error(error);
        this.toastr.error(`Erreur lors de la récupération des constructeurs.`);
      });
  }

  private _loadModelOptions(constructorName?: string): void {
    this.apiShiva.equipment_models.list({ brand__name: constructorName, autocomplete_enabled: true })
      .then((response: IListResult<IEquipmentModel>) => {
        this.modelOptions = response.results
          .map((model: IEquipmentModel) => model.branded_name)
          .sort();
      })
      .catch((error: unknown) => {
        console.error(error);
        this.toastr.error(`Erreur lors de la récupération des modèles.`);
      });
  }
}
